<template>
  <div class="box">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      :class="exData.hideHamburger ? 'hidden' : ''"
      @toggleClick="toggleSideBar"/>
    <div id="tags-view-container" class="tags-view-container hidden-sm-and-down">
      <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
        <router-link
          v-for="tag in visitedViews"
          ref="tag"
          :key="tag.path"
          :class="isActive(tag)?'active':''"
          :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
          tag="span"
          class="tags-view-item"
          @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
          @contextmenu.prevent.native="openMenu(tag,$event)">
          <span>{{ tag.title }}</span>
          <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"/>
        </router-link>
      </scroll-pane>
      <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
        <li @click="refreshSelectedTag(selectedTag)">刷新</li>
        <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">关闭</li>
        <li @click="closeOthersTags">关闭其它</li>
        <li @click="closeAllTags(selectedTag)">关闭所有</li>
      </ul>
    </div>
    <ul class="tags-view-tools">
      <!-- 刷新当前页 -->
      <li @click="refreshSelectedTag(selectedTag)">
        <el-button type="text" icon="el-icon-refresh" class="fs-16"></el-button>
      </li>
      <!-- 关闭当前页 -->
      <li @click="closeSelectedTag(selectedTag)">
        <el-button type="text" icon="el-icon-close" class="fs-16"></el-button>
      </li>
      <!-- 关闭其它页 -->
      <li @click="closeOthersTags">
        <el-tooltip
          popper-class="jw-el-tooltip-tag-view"
          effect="light"
          content="关闭其它"
          :visible-arrow="false"
          placement="bottom-end">
          <el-button type="text" icon="iconfont icon-shanchu" class="fs-16"></el-button>
        </el-tooltip>
      </li>
    </ul>
  </div>
</template>

<script>
import Hamburger from '@/components/Hamburger'
import ScrollPane from './ScrollPane'
import path from 'path'
import { mapGetters } from 'vuex'

export default {
  components: {
    ScrollPane,
    Hamburger
  },
  props: {
    exData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      affixTags: []
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.state.permission.routes
    },
    selectedTag() {
      return this.visitedViews.find(item => item.fullPath === this.$route.fullPath)
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      // 如果是首页，首页高亮
      // if (path === '/dashboard') {
      //   return '/'
      // }
      // 如果不是首页，高亮一级菜单
      const activeMenu = '/' + path.split('/')[1]
      return activeMenu
    }
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    },
    activeMenu: {
      handler: function () {
        this.updateCurrentRoutes()
      }
    }
  },
  mounted() {
    this.addTags()
    this.initTags()
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag && tag.meta && tag.meta.affix
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', this.$route)
        }
      }
    },
    addTags() {
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      if (!tags) {
        return
      }
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    // 更新左侧
    updateCurrentRoutes() {
      const index = this.routes.findIndex(item => item.path === this.activeMenu)

      if (index !== -1) {
        // 把选中路由的子路由保存store
        const route = this.routes[index]

        if (route.path.startsWith('/redirect')) {
          return
        }

        this.$store.commit('permission/SET_CURRENT_ROUTES', route)
        this.setSidebarHide(route)
      }
    },
    // 设置侧边栏的显示和隐藏
    setSidebarHide(route) {
      if (!route.children || route.children.length === 1) {
        this.$store.dispatch('app/toggleSideBarHide', true)
      } else {
        this.$store.dispatch('app/toggleSideBarHide', false)
      }
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY - 56 // 56：顶部导航的高度
      this.visible = true
      // this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    handleScroll() {
      this.closeMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #D8D9E1;
  overflow: hidden;
}

.hamburger-container {
  line-height: 36px;
  height: 100%;
  float: left;
  cursor: pointer;
  transition: background .3s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: rgba(0, 0, 0, .025)
  }
}

.tags-view-container {
  float: left;
  width: calc(100% - 172px);
  height: 36px;

  .tags-view-wrapper {

    ::v-deep .el-scrollbar__bar.is-vertical {
      visibility: hidden;
    }

    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 30px;
      line-height: 30px;
      color: #495060;
      background: #F1F4F9;
      border-radius: 4px 4px 0 0;
      padding: 0 10px;
      font-size: 14px;
      margin-left: 4px;
      margin-top: 5px;
      border: 1px solid #FFF;
      border-bottom: none;

      &:last-of-type {
        margin-right: 15px;
      }

      &.active {
        background-color: #FFF;
        color: #2F2F2F;
        border-color: #D0D5DB;
      }
    }
  }

  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: #eee;
      }
    }
  }
}

.tags-view-tools {
  float: right;
  height: 36px;
  box-sizing: border-box;

  li {
    position: relative;
    left: 0;
    top: 0;
    display: inline-block;
    border-left: 1px solid #D8D8D8;
  }

  ::v-deep .el-button {
    width: 42px;
    border: none;

    &:active, &:hover {
      &.el-button--text {
        color: #2F2F2F;
      }
    }

    &.el-button--text {
      color: #7E828B;
    }
  }
}
</style>
